'use client'
import { memo } from 'react'
import styled from 'styled-components'
import { mq, presets, presetsFluid, vw } from '@/styles'
import { Img } from '@/components'
import type { TypeCmsRasterImage } from '@/schema'
import { E_CONTENT_MEDIA_SIZE } from '@/schema'
import { ConditionalWrapper } from '@/components'
import NextLink from 'next/link'

// PENDING USE CONTENT IMAGE FROM schema
type TypeContentImage = {
  col: { from: number, expand: number }
  row: { from: number, expand: number }
  medium: TypeCmsRasterImage
  alt: string
  type: 'image' | 'media'
  imageCaption?: string
  mediaSize?: E_CONTENT_MEDIA_SIZE
	link?: {
		external: boolean
		href
	}
}

type Props = {
  data: TypeContentImage
}

export const ContentImage = memo(({ data }:Props) => {
  const { medium, mediaSize, link, imageCaption } = data
	
	// const handleClick = () => {
	// 	if(link?.external) {
	// 		window.open(link?.href, '_blank')
	// 	} else {
	// 		push(link?.href)
	// 	}
	// }

	return <ConditionalWrapper
		condition={link?.href}
		wrapperTrue={(children) => <LinkWrapper data-size={mediaSize} href={link?.href}>{children}</LinkWrapper>}
		wrapperFalse={(children) => children}>
			<>
				<Fig media={medium} unoptimized={true} />
				{imageCaption && <figcaption>{imageCaption}</figcaption>}
			</>
		</ConditionalWrapper>
})

const LinkWrapper = styled(NextLink)`
	cursor: pointer;
	width: 100%;

	&[data-size='SMALL'] {
		width: ${vw(220, 'mobile')};

		${mq.greaterThan('tablet')} {
			width: ${vw(400, 'desktop')};
		}

		${mq.greaterThan('desktop')} {
			width: 400px;
		}
	}

	&[data-size='MEDIUM'] {
		width: ${vw(345, 'mobile')};

		${mq.greaterThan('tablet')} {
			width: ${vw(650, 'desktop')};
		}

		${mq.greaterThan('desktop')} {
			width: 650px;
		}
	}

	&[data-size='BIG'] {
		width: 100%;
	}
`

const Fig = styled(Img)`
  height: auto;

	+ figcaption {
		${presetsFluid.font15()}
		margin-top: 4px;
		padding: 0 10px;
		text-align: center;
	}

  > span {
    position: relative !important;
    height: auto;
    width: 100%;
  }

  img {
    position: relative !important;
    height: 100% !important;
    width: 100% !important;
  }

  figcaption {
    ${presets.font10}
    color: var(--color-text);
    font-style: normal;
    margin-top: 10px;
    opacity: .5;
    text-align: center;
    text-transform: uppercase;
  }
`
